import React, { memo } from 'react';
import { ChevronDown, ChevronUp } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../../../../../../../shared/utils';
import { SortOrder } from '../../../../../../../../../shared/enums/order';
import './reports-sortable-header.scss';

export interface ReportsSortableHeaderProps {
  label: React.ReactNode;
  columnId: string;
  sortBy: string;
  sort: { sortBy: string; order: SortOrder } | null;
  onSort?: ((sortBy: string, order: SortOrder) => void) | null;
}

/**
 * Sortable column header with sort-by-options style (stacked ChevronUp/ChevronDown).
 * Mirrors the visual pattern from prospect sort-by-options.
 */
const ReportsSortableHeader: React.FC<ReportsSortableHeaderProps> = memo(
  ({ label, columnId, sortBy, sort, onSort }) => {
    const sortState = sort && sort.sortBy === sortBy ? sort.order : null;
    const fieldSortOrder = sortState ?? SortOrder.ASC;

    const handleToggle = (e: React.MouseEvent | React.KeyboardEvent) => {
      e.stopPropagation();
      if (!onSort) return;
      const newOrder =
        fieldSortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
      onSort(columnId, newOrder);
    };

    return (
      <div className="dialer-reports-sortable-header d-flex align-items-center gap-2 w-100">
        <span className="dialer-reports-sortable-header__label regular-2 gray-txt-9">
          {label}
        </span>
        <div
          className="dialer-reports-sortable-header__sort-type sort-by-type"
          {...(onSort ? accessibleOnClick(handleToggle) : {})}
        >
          <div className="sort-by-type-icon">
            <div
              className={`sort-by-type-icon-up ${
                sortState !== SortOrder.ASC ? 'disabled' : ''
              }`}
            >
              <ChevronUp width={12} height={12} />
            </div>
            <div
              className={`sort-by-type-icon-down ${
                sortState !== SortOrder.DESC ? 'disabled' : ''
              }`}
            >
              <ChevronDown width={12} height={12} />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

ReportsSortableHeader.displayName = 'ReportsSortableHeader';

export default ReportsSortableHeader;
